import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { FormConfig } from '../../entities/form-config';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../services/common/common.service';
import { cloneDeep } from 'lodash';
import { HttpService } from '../../services/http/http-service.service';
// import { SelectInterface } from 'sailing-front';
import { SelectConfig } from '../../entities/select-config';
import { NzTreeSelectComponent } from 'ng-zorro-antd';

export function requiredValidator(control: AbstractControl): { [key: string]: any } | null {
  const forbidden = /^\s+$/.test(control.value);
  return forbidden ? { required: { value: control.value } } : null;
}

@Component({
  selector: 'app-s-form',
  templateUrl: './s-form.component.html',
  styleUrls: ['./s-form.component.less'],
  providers: [DatePipe]
})
export class SFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() formObj: FormConfig;
  /**
   * 工程编码的前缀
   */
  @Input() prefixCode = '';
  @Output() formvalidate: EventEmitter<any> = new EventEmitter();
  // tslint:disable-next-line:no-output-rename
  @Output('selectChange') selectChangeEmit = new EventEmitter();
  @Output('treeSelectChange') treeSelectChangeEmit = new EventEmitter();
  constructor(
    private fb: FormBuilder,
    private datepipe: DatePipe,
    private commonService: CommonService,
    private httpService: HttpService,
  ) { }
  formGroup: FormGroup;
  formData: any = [];
  s: Date;
  today = new Date();
  optionList = [];
  value?: string;
  nodeTitle = '';
  style = {
    maxHeight: '150px',
    overflow: 'auto'
  };
  compareFn = (o1: any, o2: any) => (o1 && o2 ? o1.value === o2.value : o1 === o2);

  all = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) === 100000;
  }
  /** 大于等于当前年份/月份/周可选择，包含当前年份/月份/周 */
  more = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) < -1;
  }
  moreDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) < 0;
  }

  /** 小于等于当前年份/月份/周可选择，包含当前年份/月份/周 */
  less = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) > 0;
  }

  /** 大于当前年份/月份/周可选择，不包含当前年份/月份/周 */
  removecurentMore = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) < 1;
  }

  /** 小当前年份/月份/周可选择，不包含当前年份/月份/周 */
  removecurentLess = (current: Date): boolean => {
    return differenceInCalendarDays(current, this.today) > -1;
  }
  customPrecisionFn(value: string | number, precision?: number): number {
    return +Number(value).toFixed(precision);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.formObj.currentValue) {
      this.initForm();
      this.initFormData();
      this.getCascaderData();
      this.getTreeSelectData();
      this.getSelectData();
    }
  }
  ngOnDestroy(): void {
    this.removeControl();
  }

  removeControl() {
    this.formGroup = null;
  }

  initForm() {
    const formArr = this.formObj.items;
    this.formData = [];
    for (const key in this.formObj.items) {
      if (this.formObj.items.hasOwnProperty(key)) {
        const tempItem: any = this.formObj.items[key];
        tempItem.name = key;
        this.formData.push(tempItem);
      }
    }
    this.formData.forEach((f) => {
      if (this.formObj.add) {
        f.isEdit = true;
      } else if (this.formObj.update) {
        f.isEdit = false;
      }
      if (f.n && f.n.length > 0) {
        f.ui.type = 'number';
        f.type = 'number';
        if (f.n.length === 1) {
          if (parseInt(f.n[0], 0) >= 20) {
            f.ui.type = 'text';
            f.type = 'text';
          }
        }
        if (f.n.length === 2) {
          if ((parseInt(f.n[0], 0) >= 20) || (parseInt(f.n[1], 0) >= 20)) {
            f.ui.type = 'text';
            f.type = 'text';
          }
        }
      }
    });
    if (this.formObj.items) {
      this.optionList = Object.values(this.formObj.items);
    }
  }
  initFormData() {
    this.formGroup = this.fb.group({});
    this.formData.forEach((f, index) => {
      const valid = [];
      if (f.isRequire) {
        valid.push(Validators.required);
        valid.push(requiredValidator);
      }
      // 文本长度最大字符限制
      if (f.ui.type === 'text' || f.ui.type === 'textArea') {
        if (f.maxLength) {
          valid.push(Validators.maxLength(f.maxLength));
        }
      }
      // 匹配电话号码格式
      if (f.format === 'phone') {
        valid.push(Validators.pattern(/^1[3-9][0-9]{9}$|^\d{3}(-)?\d{8}$|^\d{4}(-)?\d{7}$/));
      }
      // 匹配邮政编码
      if (f.format === 'postalCode') {
        //
        valid.push(Validators.pattern(/^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/));
      }
      // 匹配纯中文
      if (f.format === 'chinese') {
        valid.push(Validators.pattern(/^(?:[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0])+$/));
      }
      // 匹配工程编码，必须数字+字母，长度1-18位
      if (f.format === 'letterNumber') {
        // console.log(new RegExp('^[a-zA-Z0-9]' + `{1,${f.maxLength}}$`));
        valid.push(Validators.pattern(new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]' + `{2,${f.maxLength}}$`)));
      }
      // 匹配数组
      if (f.ui.type === 'number' || f.n) {
        if (f.n) {
          valid.push(Validators.pattern(this.setNumberPattern(f.n)));
        }
      }
      // 自定义正则
      if (f.pattern) {
        valid.push(Validators.pattern(f.pattern));
      }
      const emptyValue = null;
      // if (f.ui.type === 'number') {
      //   emptyValue = null;
      // }
      // if (f.n && f.n.length >= 1) {
      //   if (parseInt(f.n[0], 0) >= 20) {
      //     emptyValue = null;
      //   }
      // }
      let disabled = false;
      if (f.ui.unEdit && !this.formObj.isEdit) {
        disabled = true;
      }
      this.formGroup.addControl(f.name, new FormControl({ value: f.value || emptyValue, disabled }, valid));


      if (f.ui.type === 'select' || f.ui.type === 'treeSelect' || f.ui.type === 'treeSelectMultiple') {
        this.formGroup.addControl(`${f.name}Dir`, new FormControl(null, null));
        this.formGroup.addControl(`${f.name.replace('Id', '')}Dir`, new FormControl(null, null));
        this.formGroup.addControl(`${f.name.replace('Id', 'Name')}`, new FormControl(null, null));
      }
      if (f.ui.type === 'date' || f.ui.type === 'year' || f.ui.type === 'month') {
        this.formGroup.addControl(`${f.name}Pipe`, new FormControl('', null));
      }
    });
    this.formvalidate.emit(this.formGroup);
  }

  getSelectLabel(form) {
    if (form && form.name && form.ui && form.ui.data) {
      const { name, ui: { data, mode } } = form;
      const value = this.formGroup.get(name).value;
      let dir;
      if (mode === 'multiple') {
        dir = value.map(i => data.find(x => x['value'] === i)?.label).join(',');
      } else {
        dir = data.find(x => x['value'] === value)?.label;
      }
      return dir;
    }
    return '';
  }

  getTreeLabel(form, treeSelect) {

    if (treeSelect && form && form.name && form.ui && form.ui.data) {
      const { name, ui: { data, mode } } = form;
      const value = this.formGroup.get(name).value;
      let dir;
      if (value) {
        const node = treeSelect.getTreeNodeByKey(value);
        if (node) {
          return node.title;
        }
      }
    }
    return '';
  }

  public get formValue(): any {
    return this.formGroup.getRawValue();
  }

  // 设置数字的正则
  setNumberPattern(n) {
    let result: any;
    // const pattern = '^([1-9]';
    if (n.length === 1) {
      // /(?:^[1-9]([0-9]+)?(?:\.[0-9]{1,2})?$)|(?:^(?:0){1}$)|(?:^[0-9]\.[0-9](?:[0-9])?$)/
      result = new RegExp(`(?:^[1-9]([0-9]{0,${n[0] - 1}})$)|(?:^(?:0){1}$)`);
    } else if (n.length === 2) {
      // tslint:disable-next-line:max-line-length
      result = new RegExp(`(?:^[1-9]([0-9]{0,${n[0] - 1}})?(?:\\.[0-9]{1,${n[1]}})?$)|(?:^(?:0){1}$)|(?:^[0-9](?:\\.[0-9]{1,${n[1]}})?$)`);
    }
    return result;
  }

  selectChange(e: any, options: SelectConfig) {
    this.selectChangeEmit.emit({ name: options.name, value: e, data: options.ui.data });
    if (options.ui.modelChange) {
      return options.ui.modelChange(e);
    }
    if (!options.children && !options.parent) {
      if (e && options.ui.data) {
        let dir;
        if (options.ui.mode === 'multiple') {
          dir = e.map(i => options.ui.data.find(x => x['value'] === i)?.label).join(',');
        } else {
          dir = options.ui.data.find(x => x['value'] === e)?.label;
        }
        dir && this.formGroup.controls[options.name + 'Dir'].setValue(dir);
        dir && this.formGroup.controls[options.name.replace('Id', '') + 'Dir'].setValue(dir);
      } else {
        this.formGroup.controls[options.name + 'Dir'].setValue('');
        this.formGroup.controls[options.name.replace('Id', '') + 'Dir'].setValue('');
      }
    }
    // 以下代码兼容联动查询
    const allChildrenComponents = this.optionList.filter((fItem) => {
      return fItem.parent === options.name;
    });
    if (!e) {
      allChildrenComponents.forEach((aItem) => {
        aItem.selectedValue = null;
        aItem.data = [];
        aItem.params = {};
        // this.formObj.formGroup.controls[aItem.name].setValue('', { onlySelf: true, emitEvent: false });
        this.clearChildren(aItem);
      });
    } else {
      allChildrenComponents.forEach((cItem) => {
        cItem.params[options.key] = e;
        // if (options.parent) {
        //   cItem.params = options.params;
        // }
        cItem.defaultLoad = true;
        this.getOptionsData(cItem, cItem);
        this.setChildrenParams(cItem);
      });
    }
  }

  getSelectData() {
    const selectConfigs = this.formData.filter((item) => {
      return item && (item.ui.type === 'select' || item.ui.type === 'selectMultiple');
    });
    selectConfigs.forEach((f) => {
      if (f.ui.url) {
        this.getOptionsData(f.ui, f);
      }
      // this.httpService.httpGet(url, params).subscribe(res => {
      //   f.data = res.data;
      //   f.ui.data = [];
      //   this.getOptionsData(f);
      // });
    });
    // if (e) {
    //   if (options.url && !options.defaultLoad && !options.parent) {
    // options.data = [];
    // this.getOptionsData(options);
    //   }
    // }
  }

  getTreeSelectData() {
    const cascaderConfigs = this.formData.filter((item) => {
      return item && (item.ui.type === 'treeSelect' || item.ui.type === 'treeSelectMultiple');
    });
    cascaderConfigs.forEach((f) => {
      f.ui.loading = true;
      const url = f.ui.url;
      const params = f.ui.params || {};
      this.httpService.httpGet(url, params).subscribe(res => {
        if (res.code === 1) {
          f.data = res.data;
          this.initTreeSelectData(f, res.data);
          f.ui.loading = false;
        }
      });
    });
  }

  initTreeSelectData(treeSelectConfig, data) {
    treeSelectConfig.data = [];
    const func = (tagData) => {
      if (tagData.length > 0) {
        for (let i = 0; i < tagData.length; i++) {
          const { label, value, text, key, data } = tagData[i];
          Object.defineProperty(tagData[i], 'title', { value: label || text, enumerable: true });
          Object.defineProperty(tagData[i], 'key', { value: value || key || data, enumerable: true });
          delete tagData[i].label;
          delete tagData[i].value;
          if (tagData[i].children && tagData[i].children.length > 0) {
            func(tagData[i].children);
          } else if (!tagData[i].children || tagData[i].children.length === 0) {
            Object.defineProperty(tagData[i], 'isLeaf', { value: true, enumerable: true });
          }
        }
      }
    };
    func(data);
    treeSelectConfig.ui.data = data;
  }

  getCascaderData() {
    const cascaderConfigs = this.formData.filter((item) => {
      return item && item.ui.type === 'cascader';
    });

    cascaderConfigs.forEach((f) => {
      const url = f.ui.url;
      const params = f.ui.params || {};
      this.httpService.httpGet(url, params).subscribe(res => {
        if (res.code === 1) {
          f.data = res.data;
          this.initCascaderData(f, res.data);
        }
      });
    });
  }

  initCascaderData(cascaderConfig, data) {
    cascaderConfig.data = [];
    const func = (tagData) => {
      if (tagData.length > 0) {
        for (let i = 0; i < tagData.length; i++) {
          if (tagData[i].children && tagData[i].children.length > 0) {
            func(tagData[i].children);
          } else if (!tagData[i].children || tagData[i].children.length === 0) {
            Object.defineProperty(tagData[i], 'isLeaf', { value: true, enumerable: true });
          }
        }
      }
    };
    func(data);
    cascaderConfig.ui.data = data;
  }
  cascaderChange(e: any, options: SelectConfig) {
    // let result = '';
    // if (e) {
    //   result = e.pop();
    //   this.formObj.formGroup.controls[options.name].setValue(result);
    // }
  }

  clearChildren(item) {
    if (item.children && item.parent) {
      const children = this.optionList.filter((a) => {
        return a.parent && a.parent === item.name;
      });
      if (children.length) {
        children.forEach((c) => {
          c.selectedValue = null;
          c.data = [];
          c.params = {};
          // this.formObj.formGroup.controls[c.name].setValue('', { onlySelf: true, emitEvent: false });
          this.clearChildren(c);
        });
      }
    }
  }

  setChildrenParams(item) {
    if (item.children && item.parent) {
      const children = this.optionList.filter((a) => {
        return a.parent && a.parent === item.name;
      });
      if (children.length) {
        children.forEach((c) => {
          c.params = item.params;
          this.setChildrenParams(c);
        });
      }
    }
  }

  getOptionsData(options, config) {
    options.loading = true;
    this.httpService.httpGet(options.url || options.ui.url, options.params || {}).subscribe(res => {
      if (res.code === 1) {
        this.renderOptionList(options, res.data, config);
        options.loading = false;
      }
    });
  }
  renderOptionList(options, data, config) {
    // const name = options.name;
    // const value = options.value;
    // if (data.length) {
    //   this.resetOPtionData(options, data, name, value);
    // }
    const setKey = (data) => {
      data.forEach(i => {
        i.title = i.label;
        i.key = i.value;
        if (i.children) {
          setKey(i.children);
        }
      })
    }
    setKey(data);
    let a = (this.formData || []).find(i => i.name === options.name);
    (a || { ui: {} }).ui.data = [...(data || [])];
    options.data = [...(options.data || []), ...(data || [])];
    this.formGroup.patchValue(this.formGroup.value);
    if (options.defaultLoad && options.isSelectedFirst && options.data.length) {
      if (options.mode === 'default') {
        options.selectedValue = {
          label: options.data[0].label,
          value: options.data[0].value,
          key: options.key ? options.key : null,
          children: options.children ? options.children : null,
          parent: options.parent ? options.parent : null
        };
      } else {
        options.selectedValue = [
          {
            label: options.data[0].label,
            value: options.data[0].value,
            showStep: options.data[0].showStep
          },
        ];
      }
    }
  }

  resetOPtionData(options, data, name?, value?) {
    data.forEach((item) => {
      if (name) {
        item.label = item[name];
      }
      if (value) {
        item.value = item[value];
      }
      item.key = options.key ? options.key : null;
      item.children = options.children ? options.children : null;
      item.parent = options.parent ? options.parent : null;
    });
  }

  initOptionParams(options) {
    const params = {};
    if (options.params && Object.keys(options.params).length) {
      for (const key in options.params) {
        if (options.params.hasOwnProperty(key)) {
          if (options.params[key]) {
            Object.defineProperty(params, key, {
              value: options[key],
              enumerable: true,
              writable: true,
            });
          }
        }
      }
    }
    // if (options.isPage) {
    //   Object.defineProperties(params, {
    //     page: {
    //       value: this.pramas.page ? this.pramas.page : 1,
    //       enumerable: true,
    //       writable: true,
    //     },
    //     pageSize: {
    //       value: options.pageSize ? options.pageSize : 20,
    //       enumerable: true,
    //       writable: true,
    //     },
    //   });
    // }
  }

  treeSelectChange(e, options, treeSelect) {
    this.treeSelectChangeEmit.emit({ name: options.name, value: e, node: e && treeSelect.getTreeNodeByKey(e) });
    if (e) {
      const node = treeSelect.getTreeNodeByKey(e);
      if (node) {
        this.formGroup.controls[options.name + 'Dir'].setValue(node.title);
        this.formGroup.controls[options.name.replace('Id', '') + 'Dir'].setValue(node.title);
      }
    } else {
      this.formGroup.controls[options.name + 'Dir'].setValue('');
      this.formGroup.controls[options.name.replace('Id', '') + 'Dir'].setValue('');
    }
  }

  dateChange(e, obj) {
    if (e) {
      let format = 'yyyy-MM-dd';
      if (obj.ui.showTime) {
        format = 'yyyy-MM-dd HH:mm:ss';
      }
      const result = this.datepipe.transform(e, format);
      this.formGroup.controls[obj.name + 'Pipe'].setValue(result);
    }
  }

  yearChange(e, obj) {
    if (e) {
      const result = this.datepipe.transform(e, 'yyyy');
      this.formGroup.controls[obj.name + 'Pipe'].setValue(result);
    }
  }
  monthChange(e, obj) {
    if (e) {
      const result = this.datepipe.transform(e, 'yyyy-MM');
      this.formGroup.controls[obj.name + 'Pipe'].setValue(result);
    }
  }

  validateForm() {
    for (const i in this.formGroup.controls) {
      if (this.formGroup.controls.hasOwnProperty(i)) {
        this.formGroup.controls[i].markAsDirty();
        this.formGroup.controls[i].updateValueAndValidity();
      }
    }
    return this.formGroup.valid;
  }

  subForm() {
    if (this.validateForm()) {
      //
    }
  }
  resetForm() {
    this.formGroup.reset();
  }

  initParams() {
    // this.formObj.formGroup = null;
    // this.formObj.value = {};
    // this.formObj.items = {};
    // this.formObj.add = this.commonService.isNull(this.formObj.add) ? this.formObj.add : false;
    // this.formObj.update = this.commonService.isNull(this.formObj.update) ? this.formObj.add : false;
    // if (this.formObj.add) {
    //   this.formObj.isEdit = true;
    // } else {
    //   this.formObj.isEdit = this.commonService.isNull(this.formObj.isEdit) ? this.formObj.isEdit : true;
    // }
    // this.formObj.show = this.commonService.isNull(this.formObj.show) ? this.formObj.show : false;
  }
  dateRangeChange(obj, e) {
    // if (!e.length) {
    //   this.formGroup.controls[obj.name].setValue([]);
    // } else {
    //   let format = 'yyyy-MM-dd';
    //   if (obj.ui.showTime) {
    //     format = 'yyyy-MM-dd HH:mm:ss';
    //   }
    //   e.forEach((item) => {
    //     item = this.datepipe.transform(item, format);
    //   });
    //   this.formGroup.controls[obj.name].setValue(e);
    //   this.formGroup.updateValueAndValidity();
    // }
  }
}
